import React from 'react';
import { Navbar } from './components/Navbar';
import { HeroSection } from './components/HeroSection';
import { ProcessSection } from './components/ProcessSection';
import { WhyChooseUs } from './components/WhyChooseUs';
import { ServicesSection } from './components/ServicesSection';
import { AboutSection } from './components/AboutSection';
import { CallToAction } from './components/CallToAction';
import { Footer } from './components/Footer';
export function App() {
  return <div className="bg-[#0B0C10] text-[#F5F5F5] min-h-screen w-full" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <ProcessSection data-id="element-4" />
        <WhyChooseUs data-id="element-5" />
        <ServicesSection data-id="element-6" />
        <AboutSection data-id="element-7" />
        <CallToAction data-id="element-8" />
      </main>
      <Footer data-id="element-9" />
    </div>;
}